import React, {Component, Fragment} from "react";
import { Card, CardText , CardMedia, CardTitle} from 'material-ui/Card';
import compose from 'recompose/compose';
import {connect} from "react-redux";
import TextField from 'material-ui/TextField';
import Checkbox from "material-ui/Checkbox";
import RaisedButton from 'material-ui/RaisedButton';
import Dialog from "material-ui/Dialog";
import { GridList, GridTile } from 'material-ui/GridList';
import SvgIcon from 'material-ui/SvgIcon';
import {List, ListItem} from 'material-ui/List';

import muiThemeable from 'material-ui/styles/muiThemeable';
import translate from '../../admin-on-rest/src/i18n/translate';
import { createCustomer, updateCustomer, fetchGiftcardPromos, fetchCustomer, createGiftCard } from "../../restClientActivationPage";
import {email as validateEmail} from "../../components/CRM/Form/validate";
import {validatePhone} from "../../containers/CRM/Admins/validations";
import {BMTheme} from "../../BMTheme";

import {Container, Row} from "react-rasta/lib/es5";


const cardStyle = {
    borderTop: "5px solid", 
    borderColor: BMTheme.palette.primary1Color, 
    borderTopLeftRadius: "3px", 
    borderTopRightRadius: "3px"
}

const StepIcon = (props) => (
    <SvgIcon width={24} height={24} {...props}>
        <circle cx="12" cy="12" r="10" />
        <text
            x="12"
            y="16"
            textAnchor="middle"
            fontSize= '12'
            fill= '#fff'>
            {props.icon}
        </text>
    </SvgIcon>
  );

const mapStateToProps = state => {
    return {
        configuration: state.configuration
    };
};

const enhance = compose(
    muiThemeable(),
    translate,
    connect(mapStateToProps, {})
);


class NotificationBase extends Component {

    styles = {
        warning: {
            display: "flex",
            flexDirection: "row",
            backgroundColor: "#C0392B",
            color: "white"
        },
        info: {
            display: "flex",
            flexDirection: "row",
            backgroundColor: "#333333",
            color:"white"
        },
        success: {
            display: "flex",
            flexDirection: "row",
            backgroundColor: "#16A085",
            color:"white"
        }
    };

    render() {
        const {message} = this.props.notification;
        if (!message) {
            return null;
        }

        const styles = this.styles;
        const type = this.props.notification.type || "warning";
        const {dismiss, translate} = this.props;


        return <div style={styles[type]}>
            <p style={{margin:"0.5rem"}}>
                { translate(message) }
            </p>
            <p style={{margin:"-0.5rem 0.5rem 0.5rem auto", fontSize: "28px", cursor: "pointer"}}
               onClick={dismiss}>
                &times;
            </p>
        </div>;
    }
}

const Notification = enhance(NotificationBase);

class Activation extends Component {

    state = {
        alert: null,
        new_customer: null,
        kioskId: null,
        checked: false,
        customerId: null,
        promos: [],
        promoId: null,
        phone: "",
        phoneError: null,
        email: "",
        emailError: null,
        steps: ["1", "2", "3", "4", "5"],
        notification: {},
        last_promos_request: null,
        fetchingPromos: false,
    };

    showNotification = (message, type) => {
        this.setState({notification: {message, type}});
    };

    hideNotification = () => {
        this.setState({notification: {}})
    };


    hasEmail = () => {
        if(!this.state.phoneError && this.state.phone) {
            fetchCustomer(this.state.phone).then(customer => {
                if(customer) {
                    this.setState({
                        new_customer: false,
                        email: customer.attributes.email,
                        customerId: customer.id
                    })
                } else {
                    this.setState({new_customer: true});
                    this.showNotification("resources.activation.customerNotFound", "info")
                }
                this.setState({checked: true})
            }).then(this.fetchPromos);
        } 
    }

    selectPromo = (promoId) => (_, checked) => this.setState({promoId: checked ? promoId : null})

    create = (data) => {
        const {showNotification} = this;
        createCustomer(data)
            .then(customer => {
                this.setState({
                    customerId: customer.data.id,
                    email: customer.data.email,
                });
                showNotification("resources.activation.customerAdded", "success");
            }).catch(error => {
                console.log("Error", error);
                const err = (error.payload.errors && `errors.${error.payload.errors[0].code}`) || "resources.activation.customerAddError";
                showNotification(err, "warning");
            });
    }

    update = (id, data) => {
        const {showNotification} = this;
        updateCustomer(id,data)
            .then(customer => {
                this.setState({
                    customerId: customer.data.id,
                    email: customer.data.email,
                });
                showNotification("resources.activation.customerUpdated", "success");
            }).catch(error => {
                const err = (error.payload.errors && `errors.${error.payload.errors[0].code}`) || "resources.activation.customerUpdateError";
                showNotification(err, "warning");
            });
    }

    activateCustomer = () => {
        if(!this.state.emailError) {
            const customerData = {
                email: this.state.email,
                phone: this.state.phone,
                kiosk_id: this.state.kioskId
            }
            return this.state.customerId ?
                this.update(this.state.customerId, customerData) : 
                this.create(customerData);
        }
    }

    refetch_period = () => {
        const { promos } = this.props.configuration;
        const p =  (promos ? (promos.refetch_period + Math.floor(Math.random() * promos.scatter_period)) : 60 * 60) * 1000;
        return p;
    }

    shouldFetch = (last_promos_request) => {
       if (last_promos_request) {
           return last_promos_request.error || (new Date().getTime() - last_promos_request.time.getTime()) > this.refetch_period()
       } else {
           return true;
       }
    }

    fetchPromos = () => {
        if (this.shouldFetch(this.state.last_promos_request)) {
            this.setState({fetchingPromos: true});
            fetchGiftcardPromos()
                .then(({promos, kioskId}) => {
                    this.setState({
                        promos,
                        kioskId,
                        last_promos_request: {
                            time: new Date(),
                            error: null
                        },
                        fetchingPromos: false,
                    })
                })
                .catch(e => {
                    console.log("CATCH fetching GC promos error:", e);
                    this.setState({
                        last_promos_request: {
                            time: new Date(),
                            error: e
                        },
                        fetchingPromos: false
                    });
                });
           
        } else {
            console.log('skip')
        } 
    }

    addCampaign = () => {
        const {showNotification} = this;
        const { translate } = this.props;
        createGiftCard(
            this.state.customerId,
            this.state.kioskId,
            this.state.promoId,
            this.state.new_customer)
            .then(resp => {
                this.setState({promoId: null});
                if(resp.success) {
                    this.setState({new_customer: false})
                    showNotification("resources.activation.campaignAdded", "success");
                    if(resp.message) {
                        const translated = translate(resp.message);
                        this.setState({alert: translated})
                    }
                } else {
                    showNotification("resources.activation.campaignAddFailed", "warning");
                }
            })
            .catch(error => {
                showNotification("resources.activation.campaignAddFailed", "warning");
            })
    }

    reset = () => this.setState({
        new_customer: null,
        promoId: null,
        phone: "",
        phoneError: null,
        email: "",
        emailError: null,
        checked: false,
        customerId: null,
        notification: {},
    });

    handlePhoneChange = (_, phone) => {
       /*
        normalizing phone:
          + empty phone should be left alone
          + if it begins with + assume it is already normalized and keep it
          + if it is just 0, keep it (until next character is entered)
          + if it is just 00, convert that to +
          + finally, auto-prefix with +46, replacing optional leading 0
        */
        if (phone === '' || phone[0] === '+' || phone === '0') {
            // nothing
        } else if (phone === '00') {
            phone = '+';
        } else {
            phone = phone.replace(/^0?/, '+46');
        }
        const phoneError = validatePhone(phone, "", this.props);
        this.setState({phone, phoneError});
    }

    handleEmailChange = (_, email) => {
        const emailError = validateEmail(email, "", this.props);
        this.setState({email, emailError});
    }

    componentDidMount() {
       this.fetchPromos();
    }

    closeAlert = () => {
        this.setState({alert: null})
    }

    render() {
        const { translate } = this.props;
        const  {phone, email, phoneError, emailError} = this.state;

        const phoneValid = phone && !phoneError;
        const emailValid = email && !emailError;

        const titleStyle = {borderBottom: "3px solid #E7E7E7"}

        // Use a fake prefixer when none is returned. Useful for tests
        return(
        <Fragment>
        <Notification notification={this.state.notification} dismiss={this.hideNotification}/>
        <Dialog
            actions={<RaisedButton
                primary
                onClick={this.closeAlert}
                label={"OK"}
                >
            </RaisedButton>}
            modal={true}
            open={this.state.alert}
            >
            {this.state.alert}  
        </Dialog>
        <GridList cols={1} rows={8}>
        <GridTile rows={1}>
        <Card>
            <CardTitle title={translate("resources.activation.description")} style={titleStyle} />
            <CardText>
                <div style={{"display": 'flex', "flexDirection": 'row'}}>
                    <div style={{"paddingRight": '2em'}}>
                        <TextField
                            id="phone"
                            placeholder={translate("resources.activation.fields.phone")}
                            disabled={this.state.checked}
                            onChange={this.handlePhoneChange}
                            errorText={this.state.phoneError}
                            value={this.state.phone}>
                        </TextField>
                    </div>
                    {this.state.checked ?
                        <div style={{"paddingRight": '2em'}}>
                            <TextField
                                id="email"
                                placeholder={translate("resources.activation.fields.email")}
                                onChange={this.handleEmailChange}
                                errorText={this.state.emailError}
                                value={this.state.email}>
                            </TextField>
                        </div> :
                        null
                    }
                    {!this.state.checked ?
                        <div>
                            <RaisedButton
                                primary
                                label={translate("resources.activation.fields.check")}
                                disabled={!phoneValid}
                                onClick={this.hasEmail}>
                            </RaisedButton>
                        </div> :
                        null
                    }
                    {this.state.checked ?
                        <div style={{"paddingRight": '2em'}}>
                            <RaisedButton
                                primary
                                label={this.state.customerId ? translate("resources.activation.fields.update") : translate("resources.activation.fields.add")}
                                disabled={!emailValid}
                                onClick={this.activateCustomer}>
                            </RaisedButton>
                        </div> :
                        null
                    }
                    {this.state.checked ?
                        <div style={{marginLeft: "auto"}}>
                            <RaisedButton
                                primary
                                label={translate("resources.activation.fields.reset")}
                                onClick={this.reset}>
                            </RaisedButton>
                        </div> :
                        null
                    }
                </div>
            </CardText>
        </Card>
        </GridTile>
        <GridTile rows={7}>
        <Card style={cardStyle}>
            <CardText>
                <GridList cols={4} rows={6}>
                    <GridTile cols={3} rows={6} style={{borderRight: "3px solid #E7E7E7", overflowY: 'auto'}}>
                        <Container>
                            <Row justifyContent="flex-start">
                            {this.state.promos.map(promo =>
                                    <Card key={promo.id} style={{margin:"10px", "height": "450px", "width": "300px"}}>
                                        <CardMedia style={{"height": "400px", "width": "300px"}}>
                                            <img src={promo.attributes.images.small.src} style={{"objectFit": "contain"}} alt=""/>
                                        </CardMedia>
                                        <CardText style={{"height": "50px", "width": "300px"}}>
                                            <Checkbox
                                                disabled={!(this.state.customerId && this.state.email) || this.state.fetchingPromos}
                                                onCheck={this.selectPromo(promo.id)}
                                                checked={promo.id === this.state.promoId}
                                                style={{
                                                    width: '1%',
                                                    margin: '0 auto',
                                                }}
                                            />
                                        </CardText>
                                    </Card>
                                )}
                            </Row>
                        </Container>
                    </GridTile>
                    <GridTile cols={1} rows={6}>
                        <h3 style={{"textAlign": "center"}}>{translate(`resources.activation.steps.title`)}</h3>
                        <List>
                        {this.state.steps.map(step => <ListItem key={step}
                                primaryText={translate(`resources.activation.steps.${step}`)}
                                leftIcon={<StepIcon icon={step} color={"red"}/>}
                                />)}
                            </List>
                        <br></br>
                        <div style={{"display": 'flex', "flexDirection": 'row', justifyContent:"center"}}>
                            <RaisedButton
                                disabled={!this.state.promoId}
                                onClick={this.addCampaign}
                                primary
                                label={translate("resources.activation.fields.addCampaign")}>
                            </RaisedButton>
                        </div>
                    </GridTile>
                </GridList>
            </CardText>
        </Card>
        </GridTile>
        </GridList>
        </Fragment>
        )
    }
}



export default enhance(Activation);


// WEBPACK FOOTER //
// ./src/containers/Activation/index.js